import { clientEnv, type ClientEnv } from './env';

/** Where the hub debug panel may exist: local only (never QA, which is APP_ENV `development`). */
const HUB_DEBUG_PANEL_ENVS: readonly ClientEnv['NEXT_PUBLIC_APP_ENV'][] = ['local'];

export const FEATURES = {
  get enableReports() {
    return clientEnv.NEXT_PUBLIC_APP_ENV !== 'local';
  },
  get enableDevtools() {
    return clientEnv.NEXT_PUBLIC_APP_ENV === 'local';
  },
  // The hub's emergency switch (env.ts explains what turning it off costs).
  get enableNotifications() {
    return clientEnv.NEXT_PUBLIC_NOTIFICATIONS_ENABLED;
  },
  // NEXT_PUBLIC_HUB_DEBUG_PANEL can only hide it. APP_ENV, not NODE_ENV (QA is a production build).
  // `!== false`: an unparsed env has no schema default.
  get enableHubDebugPanel() {
    return (
      HUB_DEBUG_PANEL_ENVS.includes(clientEnv.NEXT_PUBLIC_APP_ENV) &&
      clientEnv.NEXT_PUBLIC_HUB_DEBUG_PANEL !== false
    );
  },
} as const;
